// frontend/src/layouts/MainLayout.js

import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, IconButton, CssBaseline } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DescriptionIcon from '@mui/icons-material/Description';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CategoryIcon from '@mui/icons-material/Category';
import LogoutIcon from '@mui/icons-material/Logout';
import GroupIcon from '@mui/icons-material/Group'; 
import { useAuth } from '../context/AuthContext';
import StarIcon from '@mui/icons-material/Star';

const drawerWidth = 250;

const MainLayout = () => {
  const { user, logout } = useAuth(); 
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const menuItems = [
    { text: 'Meus Pedidos', icon: <DescriptionIcon />, path: '/' },
    { text: 'Novo Pedido', icon: <AddCircleOutlineIcon />, path: '/novo-pedido' },
    { text: 'Gerenciar Áreas', icon: <CategoryIcon />, path: '/areas' },
    { text: 'Gerenciar Favoritos', icon: <StarIcon />, path: '/favoritos' }, 
  ];

  if (user && user.is_company_admin) {
    menuItems.push({ 
      text: 'Gestão de Equipe', 
      icon: <GroupIcon />, 
      path: '/team-management' 
    });
  }


  const drawerContent = (
    <Box
      sx={{ width: drawerWidth }}
      role="presentation"
      onClick={handleDrawerToggle}
      onKeyDown={handleDrawerToggle}
    >
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src="/logo-completa.png" alt="ITAPOÁ SIGN" style={{ maxWidth: '100%', height: 45, objectFit: 'contain' }} />
      </Box>
      <Divider />
      <List>
        {menuItems.map((item) => {
          const isSelected = location.pathname === item.path;
          return (
            <ListItem key={item.text} disablePadding>
              <ListItemButton onClick={() => navigate(item.path)} selected={isSelected}>
                <ListItemIcon sx={{ color: isSelected ? 'primary.main' : 'inherit' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={logout}>
            <ListItemIcon><LogoutIcon /></ListItemIcon>
            <ListItemText primary="Sair" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#0D47A1' }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img src="/logo.png" alt="ITAPOÁ SIGN" style={{ height: 34, width: 34, borderRadius: 6 }} />
            <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 600, letterSpacing: '0.5px' }}>
              ITAPOÁ SIGN - Assinatura Digital
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {drawerContent}
      </Drawer>
      
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;